import { prop } from "./utils"

function createURLString(base = '', urls = [], searchParams = {}) {
    let _URL = new URL(base)
    for (let key in urls) _URL = new URL(urls[key], _URL)
    for (let key in searchParams) _URL.searchParams.append(key, searchParams[key])

    return _URL.toString()
}

function simplyGetRootDomain() {
    let domain
    const targetRootDomain = ['.foxit.com', '.foxit.co.jp', '.foxitsoftware.cn', '.connectedpdf.com', '.foxitcloud.com']
    const host = prop(location, 'host');
    
    if (host.indexOf('localhost') > -1) {
        domain = 'localhost'
    } else {
        targetRootDomain.some((item) => {
            if (host.indexOf(item) > -1) {
                domain = item

                return true
            }
        })
    }
    
    return domain
}

export { createURLString, simplyGetRootDomain }
